import { Layout } from "@/components/layout/Layout";
import { PageHero } from "@/components/shared/PageHero";

export default function PoliticaPrivacidade() {
  return (
    <Layout>
      <PageHero title="Aviso de Privacidade" subtitle="COGNI SYSTEMS LTDA" variant="gradient" />

      <section className="section-padding section-alt">
        <div className="container-narrow">
          <div className="bg-background rounded-xl sm:rounded-2xl border border-border p-5 sm:p-8 md:p-12 shadow-lg">
            <div className="prose prose-sm sm:prose-base lg:prose-lg max-w-none prose-headings:text-foreground prose-p:text-muted-foreground prose-li:text-muted-foreground prose-strong:text-foreground prose-a:text-primary hover:prose-a:text-primary/80">
              <p className="text-sm text-muted-foreground mb-8">
                <strong>Última Atualização:</strong> 26 de março de 2023
              </p>

              <h2>Olá! Seja Bem-vindo(a) ao Portal da COGNI!</h2>

              <p>
                Inicialmente, agradecemos muito a sua confiança e por acreditar nesta parceria! Saiba que quando você
                ingressa em nosso aplicativo, você confia-nos seus dados e informações. Nos comprometemos a manter essa
                confiança.
              </p>

              <p>
                Nosso Aviso de Privacidade explicará a você, de forma clara e acessível, quais serão as suas informações
                e dados pessoais coletados, com quem serão compartilhados e em que locais serão armazenados.
              </p>

              <p>
                Caso você deseje exercer qualquer um de seus direitos, expressos na LGPD, preencher o{" "}
                <a href="/contato">Formulário de Atendimento ao titular de dados</a>.
              </p>

              <p>
                Ao acessar e navegar por nosso aplicativo, você aceita nosso Aviso, estando ciente e em total acordo com
                a forma como utilizaremos as suas informações e seus dados.
              </p>

              <p>Para facilitar a sua compreensão, saiba que nosso Aviso está organizado da seguinte forma:</p>

              <ol>
                <li>1. Informações Coletadas</li>
                <li>2. Como Usamos seus Dados</li>
                <li>3. Compartilhamento de Dados</li>
                <li>4. Direitos dos Titulares</li>
                <li>5. Segurança das Informações</li>
                <li>6. Atualização do nosso Aviso</li>
                <li>7. Legislação Aplicável</li>
              </ol>

              <hr className="my-8" />

              <h2>1. INFORMAÇÕES COLETADAS</h2>

              <p>Para que interaja conosco, nós coletamos os seguintes tipos de informações:</p>

              <h3>1.1. Informações fornecidas por você:</h3>
              <ul>
                <li>
                  <strong>Dados de cadastro</strong> - quando você se cadastra em nosso aplicativo, nos fornece as
                  seguintes informações: Nome, telefone, e-mail, empresa e cargo.
                </li>
                <li>
                  <strong>Informações de autenticação</strong> - visando proporcionar um ambiente seguro, podemos
                  solicitar as seguintes informações de identificação e autenticação: e-mail, telefone e senha.
                </li>
              </ul>

              <h3>1.2. Informações geradas automaticamente:</h3>
              <ul>
                <li>
                  <strong>Registros de acesso:</strong> A COGNI coleta, de forma automática, os registros de acesso à
                  aplicação, que podem incluir o nome de usuário, e-mail, endereço IP, com data e hora, utilizado para
                  acessar o aplicativo da COGNI. Esses dados são de coleta obrigatória, conforme estipulado pela Lei nº
                  12.965/2014, mas serão fornecidos para terceiros apenas com a sua autorização expressa ou em razão de
                  decisão judicial.
                </li>
                <li>
                  <strong>Registros de telemetria</strong> - A COGNI coleta, quando parte do escopo contratual, dados
                  referentes a telemetria, incluindo mas não se limitando à:
                  <ul>
                    <li>Dados de energia elétrica;</li>
                    <li>Dados de utilidades (gás, vapor, ar comprimido, água);</li>
                    <li>Dados de produção;</li>
                    <li>Outras fontes de dados à depender do escopo contratual;</li>
                  </ul>
                </li>
                <li>
                  <strong>Registros inseridos via formulário de dados</strong> - A COGNI coleta, quando fornecido pelo
                  cliente com autorização para tal, dados preenchidos em formulários disponíveis no aplicativo COGNI. Os
                  mesmos são acompanhados de dados como usuário e data / hora do preenchimento e edição.
                </li>
                <li>
                  <strong>Registros sincronizados via APIs de dados</strong> - A COGNI coleta, quando autorizado pelo
                  cliente, dados relativos a outros sistemas / plataformas conectados através de Interface de
                  Programação de Aplicativos (APIs) necessários para a composição de informações e indicadores no
                  aplicativo COGNI.
                </li>
                <li>
                  <strong>
                    Registros enviados por e-mail ou servidor de Protocolo de Transferência de Arquivos (FTP)
                  </strong>{" "}
                  - A COGNI coleta, quando enviado pelo cliente para e-mail previamente acordado, dados relativos a
                  outros sistemas ou mesmo o inseridos de forma manual em arquivos de planilhas, arquivos de texto e/ou
                  outros tipos de arquivo necessários para a composição de informações e indicadores.
                </li>
                <li>
                  <strong>
                    Registros sincronizados junto à fornecedores terceiros de propriedade ou posse do cliente
                  </strong>{" "}
                  - A COGNI coleta, quando autorizado pelo cliente de forma expressa e necessário para a execução das
                  atividades, arquivos sincronizados de outras fontes, como concessionárias de energia, água, gás,
                  dentre outras, bem como de outros fornecedores com acesso de dados de login e senha fornecidos pelo
                  cliente.
                </li>
                <li>
                  <strong>Comunicações com a COGNI</strong> - Quando você se comunica com a COGNI, coletamos informações
                  sobre sua comunicação, incluindo metadados como data, IP, hora das comunicações e todo o seu conteúdo,
                  assim como qualquer informação que você escolha fornecer.
                </li>
                <li>
                  <strong>Cookies e tecnologias semelhantes</strong> - Nós utilizamos cookies, isto é, arquivos de texto
                  gerados e armazenados no seu navegador ou aparelho por sites, aplicativos e anúncios online.
                </li>
              </ul>

              <hr className="my-8" />

              <h2>2. COMO USAMOS SEUS DADOS</h2>

              <p>
                Nós prezamos muito pela sua privacidade e é justamente por isso que todos os dados e informações sobre
                você são tratadas com a mais alta confidencialidade, sendo usados somente para os fins ora descritos e
                por você conhecidos e autorizados.
              </p>

              <h3>2.1. Como podemos usar seus dados pessoais?</h3>
              <p>Poderemos utilizar seus dados para:</p>
              <ul>
                <li>Permitir que você acesse e utilize todas as funcionalidades do nosso aplicativo;</li>
                <li>Cumprir obrigações legais.</li>
                <li>
                  Enviar mensagens, alertas, notificações e atualizações a respeito de suporte ou serviço prestado,
                  produtos, serviços, promoções, notícias, atualizações, eventos e outros assuntos que você possa ter
                  interesse;
                </li>
                <li>Detecção e prevenção de fraudes, spam e incidentes de segurança;</li>
                <li>
                  Verificar ou autenticar as informações fornecidas por você, inclusive comparando a dados coletados de
                  outras fontes;
                </li>
                <li>Para qualquer fim que você autorizar no momento da coleta de dados;</li>
              </ul>

              <p>
                Poderemos, eventualmente, utilizar dados para finalidades diversas das previstas neste Aviso de
                Privacidade, mas todas elas estarão dentro das suas legítimas expectativas. O eventual uso dos seus
                dados para finalidades que não cumpram com essa prerrogativa será feito mediante sua autorização prévia.
              </p>

              <h3>2.2. Exclusão dos dados</h3>
              <p>
                Todos os dados coletados serão excluídos de nossos servidores mediante sua requisição, por procedimento
                gratuito e facilitado, ou quando estes deixarem de ser necessários ou relevantes para o oferecimento de
                nossos serviços, salvo se houver qualquer outra razão para a sua manutenção, como eventual obrigação
                legal de retenção de dados ou necessidade de preservação destes para resguardo de direitos da COGNI.
              </p>

              <hr className="my-8" />

              <h2>3. COMPARTILHAMENTO DAS INFORMAÇÕES</h2>

              <p>
                Todas as informações que armazenamos sobre você podem ser consideradas ativos no caso de negociações em
                que a COGNI fizer parte. Nesse sentido, nos reservamos no direito de, por exemplo, incluir seus dados
                dentre os ativos da empresa caso esta venha a ser vendida, adquirida ou fundida com outra. Por meio
                deste Aviso você concorda e está ciente desta possibilidade.
              </p>

              <p>
                A COGNI deverá fornecer seus dados e informações, caso seja requisitado por meio de decisão judicial.
              </p>

              <hr className="my-8" />

              <h2>4. DIREITOS DOS TITULARES</h2>

              <p>
                A Lei Geral de Proteção de Dados estabelece que o titular tem o direito de obter do controlador, em
                relação às suas informações pessoais por ele tratados, a qualquer momento e mediante requisição:
              </p>

              <ul>
                <li>A confirmação da existência de tratamento;</li>
                <li>Acesso aos dados;</li>
                <li>Correção de dados incompletos, inexatos ou desatualizados;</li>
                <li>
                  Anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desconformidade com a Lei;
                </li>
                <li>Portabilidade dos dados;</li>
                <li>Eliminação dos dados pessoais tratados com o seu consentimento;</li>
                <li>
                  Informações das entidades públicas e privadas com as quais o controlador realizou uso compartilhado de
                  dados;
                </li>
                <li>
                  Informações sobre a possibilidade de não fornecer seu consentimento e as consequências da negativa;
                </li>
                <li>Revogação do consentimento, conforme previsto no art. 8º, §5º, da LGPD.</li>
              </ul>

              <p>
                Caso o titular de dados queira exercer qualquer um de seus direitos expressos na LGPD, bem como tirar
                dúvidas referentes a esta documentação, basta preencher o
                <a href="/contato">Formulário de Atendimento ao titular de dados</a>.
              </p>

              <hr className="my-8" />

              <h2>5. SEGURANÇA DAS INFORMAÇÕES</h2>

              <p>
                Todos os seus dados são confidenciais e somente as pessoas com as devidas autorizações terão acesso a
                eles. A COGNI empenha todos os esforços razoáveis de mercado para garantir a segurança dos nossos
                sistemas e dos seus dados. Nossos servidores estão localizados em diferentes locais para garantir
                estabilidade e segurança, e somente podem ser acessados por meio de canais de comunicação previamente
                autorizados.
              </p>

              <p>
                Todas as suas informações serão, sempre que possível, criptografadas, caso não inviabilizem o seu uso
                pela plataforma. A qualquer momento você poderá requisitar cópia dos seus dados armazenados em nossos
                sistemas. Manteremos os dados e informações somente até quando estas forem necessárias ou relevantes
                para as finalidades descritas neste Aviso, ou em caso de períodos pré-determinados por lei, ou até
                quando estas forem necessárias para a manutenção de interesses legítimos da COGNI.
              </p>

              <p>
                Importante esclarecer que não temos como garantir que todos os seus dados em nossa plataforma estarão
                livres de acessos não autorizados, principalmente caso haja compartilhamento indevido das credenciais
                necessárias para acessar o nosso aplicativo.
              </p>

              <p>
                Recomendamos que você mantenha sua senha de acesso em local seguro, sendo desaconselhado o
                compartilhamento desta com terceiros. Você se compromete a notificar a COGNI, imediatamente, através de
                meio seguro, a respeito de qualquer uso não autorizado de sua conta, bem como o acesso não autorizado
                por terceiros a esta.
              </p>

              <hr className="my-8" />

              <h2>6. ATUALIZAÇÕES DO NOSSO AVISO</h2>

              <p>
                A COGNI se reserva no direito de atualizar o nosso Aviso de Privacidade quantas vezes forem necessárias,
                a fim de fornecer a você informações mais seguras e melhorar cada vez mais a sua experiência.
              </p>

              <hr className="my-8" />

              <h2>7. LEGISLAÇÃO APLICÁVEL</h2>

              <p>
                Este documento é regido e deve ser interpretado conforme as leis e atos normativos que compõem o
                ordenamento jurídico brasileiro. Fica eleito o Foro da Comarca de Aparecida de Goiânia, Goiás, como o
                competente para dirimir eventuais questões oriundas do presente documento, com expressa renúncia a
                qualquer outro.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
